// @ts-nocheck

export const localeCodes =  [
  "en",
  "fr",
  "nl",
  "de",
  "es",
  "it",
  "pl",
  "ko",
  "uk"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_5ef3bb15",
      load: () => import("#nuxt-i18n/5ef3bb15" /* webpackChunkName: "locale_en_46json_5ef3bb15" */),
      cache: true
    },
    {
      key: "locale_en_46json_20fb6258",
      load: () => import("#nuxt-i18n/20fb6258" /* webpackChunkName: "locale_en_46json_20fb6258" */),
      cache: true
    },
    {
      key: "locale_en_46json_b7a6725b",
      load: () => import("#nuxt-i18n/b7a6725b" /* webpackChunkName: "locale_en_46json_b7a6725b" */),
      cache: true
    },
    {
      key: "locale_en_46json_2d7f2c26",
      load: () => import("#nuxt-i18n/2d7f2c26" /* webpackChunkName: "locale_en_46json_2d7f2c26" */),
      cache: true
    },
    {
      key: "locale_en_46json_0f89c35a",
      load: () => import("#nuxt-i18n/0f89c35a" /* webpackChunkName: "locale_en_46json_0f89c35a" */),
      cache: true
    },
    {
      key: "locale_en_46json_509aac86",
      load: () => import("#nuxt-i18n/509aac86" /* webpackChunkName: "locale_en_46json_509aac86" */),
      cache: true
    },
    {
      key: "locale_en_46json_2842bad5",
      load: () => import("#nuxt-i18n/2842bad5" /* webpackChunkName: "locale_en_46json_2842bad5" */),
      cache: true
    },
    {
      key: "locale_en_46json_50a14a69",
      load: () => import("#nuxt-i18n/50a14a69" /* webpackChunkName: "locale_en_46json_50a14a69" */),
      cache: true
    },
    {
      key: "locale_en_46json_2c89b3ff",
      load: () => import("#nuxt-i18n/2c89b3ff" /* webpackChunkName: "locale_en_46json_2c89b3ff" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_5521cbe2",
      load: () => import("#nuxt-i18n/5521cbe2" /* webpackChunkName: "locale_fr_46json_5521cbe2" */),
      cache: true
    },
    {
      key: "locale_fr_46json_987ea925",
      load: () => import("#nuxt-i18n/987ea925" /* webpackChunkName: "locale_fr_46json_987ea925" */),
      cache: true
    },
    {
      key: "locale_fr_46json_05e380d1",
      load: () => import("#nuxt-i18n/05e380d1" /* webpackChunkName: "locale_fr_46json_05e380d1" */),
      cache: true
    },
    {
      key: "locale_fr_46json_ef82c5df",
      load: () => import("#nuxt-i18n/ef82c5df" /* webpackChunkName: "locale_fr_46json_ef82c5df" */),
      cache: true
    },
    {
      key: "locale_fr_46json_eb4f112c",
      load: () => import("#nuxt-i18n/eb4f112c" /* webpackChunkName: "locale_fr_46json_eb4f112c" */),
      cache: true
    },
    {
      key: "locale_fr_46json_f76accbe",
      load: () => import("#nuxt-i18n/f76accbe" /* webpackChunkName: "locale_fr_46json_f76accbe" */),
      cache: true
    },
    {
      key: "locale_fr_46json_7b06716d",
      load: () => import("#nuxt-i18n/7b06716d" /* webpackChunkName: "locale_fr_46json_7b06716d" */),
      cache: true
    },
    {
      key: "locale_fr_46json_c0ed8b12",
      load: () => import("#nuxt-i18n/c0ed8b12" /* webpackChunkName: "locale_fr_46json_c0ed8b12" */),
      cache: true
    },
    {
      key: "locale_fr_46json_209ea2a0",
      load: () => import("#nuxt-i18n/209ea2a0" /* webpackChunkName: "locale_fr_46json_209ea2a0" */),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_nl_46json_47c8311a",
      load: () => import("#nuxt-i18n/47c8311a" /* webpackChunkName: "locale_nl_46json_47c8311a" */),
      cache: true
    },
    {
      key: "locale_nl_46json_a1bb1c7b",
      load: () => import("#nuxt-i18n/a1bb1c7b" /* webpackChunkName: "locale_nl_46json_a1bb1c7b" */),
      cache: true
    },
    {
      key: "locale_nl_46json_e3147e37",
      load: () => import("#nuxt-i18n/e3147e37" /* webpackChunkName: "locale_nl_46json_e3147e37" */),
      cache: true
    },
    {
      key: "locale_nl_46json_b0c28d63",
      load: () => import("#nuxt-i18n/b0c28d63" /* webpackChunkName: "locale_nl_46json_b0c28d63" */),
      cache: true
    },
    {
      key: "locale_nl_46json_9dc2ae01",
      load: () => import("#nuxt-i18n/9dc2ae01" /* webpackChunkName: "locale_nl_46json_9dc2ae01" */),
      cache: true
    },
    {
      key: "locale_nl_46json_7ec2a9ad",
      load: () => import("#nuxt-i18n/7ec2a9ad" /* webpackChunkName: "locale_nl_46json_7ec2a9ad" */),
      cache: true
    },
    {
      key: "locale_nl_46json_9d3a41b5",
      load: () => import("#nuxt-i18n/9d3a41b5" /* webpackChunkName: "locale_nl_46json_9d3a41b5" */),
      cache: true
    },
    {
      key: "locale_nl_46json_7e5ffc32",
      load: () => import("#nuxt-i18n/7e5ffc32" /* webpackChunkName: "locale_nl_46json_7e5ffc32" */),
      cache: true
    },
    {
      key: "locale_nl_46json_8f3e30a7",
      load: () => import("#nuxt-i18n/8f3e30a7" /* webpackChunkName: "locale_nl_46json_8f3e30a7" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_edf0306a",
      load: () => import("#nuxt-i18n/edf0306a" /* webpackChunkName: "locale_de_46json_edf0306a" */),
      cache: true
    },
    {
      key: "locale_de_46json_f0f14150",
      load: () => import("#nuxt-i18n/f0f14150" /* webpackChunkName: "locale_de_46json_f0f14150" */),
      cache: true
    },
    {
      key: "locale_de_46json_708007d2",
      load: () => import("#nuxt-i18n/708007d2" /* webpackChunkName: "locale_de_46json_708007d2" */),
      cache: true
    },
    {
      key: "locale_de_46json_5179cdcd",
      load: () => import("#nuxt-i18n/5179cdcd" /* webpackChunkName: "locale_de_46json_5179cdcd" */),
      cache: true
    },
    {
      key: "locale_de_46json_e3a7ba04",
      load: () => import("#nuxt-i18n/e3a7ba04" /* webpackChunkName: "locale_de_46json_e3a7ba04" */),
      cache: true
    },
    {
      key: "locale_de_46json_17e43d3e",
      load: () => import("#nuxt-i18n/17e43d3e" /* webpackChunkName: "locale_de_46json_17e43d3e" */),
      cache: true
    },
    {
      key: "locale_de_46json_3b69aa1b",
      load: () => import("#nuxt-i18n/3b69aa1b" /* webpackChunkName: "locale_de_46json_3b69aa1b" */),
      cache: true
    },
    {
      key: "locale_de_46json_3e18811b",
      load: () => import("#nuxt-i18n/3e18811b" /* webpackChunkName: "locale_de_46json_3e18811b" */),
      cache: true
    },
    {
      key: "locale_de_46json_3bd1f143",
      load: () => import("#nuxt-i18n/3bd1f143" /* webpackChunkName: "locale_de_46json_3bd1f143" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_42a98a00",
      load: () => import("#nuxt-i18n/42a98a00" /* webpackChunkName: "locale_es_46json_42a98a00" */),
      cache: true
    },
    {
      key: "locale_es_46json_6a9d1635",
      load: () => import("#nuxt-i18n/6a9d1635" /* webpackChunkName: "locale_es_46json_6a9d1635" */),
      cache: true
    },
    {
      key: "locale_es_46json_41a5aa42",
      load: () => import("#nuxt-i18n/41a5aa42" /* webpackChunkName: "locale_es_46json_41a5aa42" */),
      cache: true
    },
    {
      key: "locale_es_46json_5be06087",
      load: () => import("#nuxt-i18n/5be06087" /* webpackChunkName: "locale_es_46json_5be06087" */),
      cache: true
    },
    {
      key: "locale_es_46json_24cfc1b0",
      load: () => import("#nuxt-i18n/24cfc1b0" /* webpackChunkName: "locale_es_46json_24cfc1b0" */),
      cache: true
    },
    {
      key: "locale_es_46json_2028a926",
      load: () => import("#nuxt-i18n/2028a926" /* webpackChunkName: "locale_es_46json_2028a926" */),
      cache: true
    },
    {
      key: "locale_es_46json_2b7ec610",
      load: () => import("#nuxt-i18n/2b7ec610" /* webpackChunkName: "locale_es_46json_2b7ec610" */),
      cache: true
    },
    {
      key: "locale_es_46json_edca285f",
      load: () => import("#nuxt-i18n/edca285f" /* webpackChunkName: "locale_es_46json_edca285f" */),
      cache: true
    },
    {
      key: "locale_es_46json_5a043d44",
      load: () => import("#nuxt-i18n/5a043d44" /* webpackChunkName: "locale_es_46json_5a043d44" */),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_46json_332e4db9",
      load: () => import("#nuxt-i18n/332e4db9" /* webpackChunkName: "locale_it_46json_332e4db9" */),
      cache: true
    },
    {
      key: "locale_it_46json_58545d44",
      load: () => import("#nuxt-i18n/58545d44" /* webpackChunkName: "locale_it_46json_58545d44" */),
      cache: true
    },
    {
      key: "locale_it_46json_4096255b",
      load: () => import("#nuxt-i18n/4096255b" /* webpackChunkName: "locale_it_46json_4096255b" */),
      cache: true
    },
    {
      key: "locale_it_46json_53adcc03",
      load: () => import("#nuxt-i18n/53adcc03" /* webpackChunkName: "locale_it_46json_53adcc03" */),
      cache: true
    },
    {
      key: "locale_it_46json_b69ec30d",
      load: () => import("#nuxt-i18n/b69ec30d" /* webpackChunkName: "locale_it_46json_b69ec30d" */),
      cache: true
    },
    {
      key: "locale_it_46json_3676672a",
      load: () => import("#nuxt-i18n/3676672a" /* webpackChunkName: "locale_it_46json_3676672a" */),
      cache: true
    },
    {
      key: "locale_it_46json_c67d322d",
      load: () => import("#nuxt-i18n/c67d322d" /* webpackChunkName: "locale_it_46json_c67d322d" */),
      cache: true
    },
    {
      key: "locale_it_46json_30eeaa23",
      load: () => import("#nuxt-i18n/30eeaa23" /* webpackChunkName: "locale_it_46json_30eeaa23" */),
      cache: true
    },
    {
      key: "locale_it_46json_623acada",
      load: () => import("#nuxt-i18n/623acada" /* webpackChunkName: "locale_it_46json_623acada" */),
      cache: true
    }
  ],
  pl: [
    {
      key: "locale_pl_46json_a66d43e8",
      load: () => import("#nuxt-i18n/a66d43e8" /* webpackChunkName: "locale_pl_46json_a66d43e8" */),
      cache: true
    },
    {
      key: "locale_pl_46json_b42cde0a",
      load: () => import("#nuxt-i18n/b42cde0a" /* webpackChunkName: "locale_pl_46json_b42cde0a" */),
      cache: true
    },
    {
      key: "locale_pl_46json_ebe178e8",
      load: () => import("#nuxt-i18n/ebe178e8" /* webpackChunkName: "locale_pl_46json_ebe178e8" */),
      cache: true
    },
    {
      key: "locale_pl_46json_0038c3d9",
      load: () => import("#nuxt-i18n/0038c3d9" /* webpackChunkName: "locale_pl_46json_0038c3d9" */),
      cache: true
    },
    {
      key: "locale_pl_46json_d4f7fe5f",
      load: () => import("#nuxt-i18n/d4f7fe5f" /* webpackChunkName: "locale_pl_46json_d4f7fe5f" */),
      cache: true
    },
    {
      key: "locale_pl_46json_4ec934f5",
      load: () => import("#nuxt-i18n/4ec934f5" /* webpackChunkName: "locale_pl_46json_4ec934f5" */),
      cache: true
    },
    {
      key: "locale_pl_46json_fedcd01d",
      load: () => import("#nuxt-i18n/fedcd01d" /* webpackChunkName: "locale_pl_46json_fedcd01d" */),
      cache: true
    },
    {
      key: "locale_pl_46json_c5b257b0",
      load: () => import("#nuxt-i18n/c5b257b0" /* webpackChunkName: "locale_pl_46json_c5b257b0" */),
      cache: true
    },
    {
      key: "locale_pl_46json_8e205c4d",
      load: () => import("#nuxt-i18n/8e205c4d" /* webpackChunkName: "locale_pl_46json_8e205c4d" */),
      cache: true
    }
  ],
  ko: [
    {
      key: "locale_ko_46json_37d42559",
      load: () => import("#nuxt-i18n/37d42559" /* webpackChunkName: "locale_ko_46json_37d42559" */),
      cache: true
    },
    {
      key: "locale_ko_46json_d567aa51",
      load: () => import("#nuxt-i18n/d567aa51" /* webpackChunkName: "locale_ko_46json_d567aa51" */),
      cache: true
    },
    {
      key: "locale_ko_46json_50b7b9b0",
      load: () => import("#nuxt-i18n/50b7b9b0" /* webpackChunkName: "locale_ko_46json_50b7b9b0" */),
      cache: true
    },
    {
      key: "locale_ko_46json_00440b0c",
      load: () => import("#nuxt-i18n/00440b0c" /* webpackChunkName: "locale_ko_46json_00440b0c" */),
      cache: true
    },
    {
      key: "locale_ko_46json_c924e47d",
      load: () => import("#nuxt-i18n/c924e47d" /* webpackChunkName: "locale_ko_46json_c924e47d" */),
      cache: true
    },
    {
      key: "locale_ko_46json_6d420610",
      load: () => import("#nuxt-i18n/6d420610" /* webpackChunkName: "locale_ko_46json_6d420610" */),
      cache: true
    },
    {
      key: "locale_ko_46json_11e1857e",
      load: () => import("#nuxt-i18n/11e1857e" /* webpackChunkName: "locale_ko_46json_11e1857e" */),
      cache: true
    },
    {
      key: "locale_ko_46json_f1a3ee13",
      load: () => import("#nuxt-i18n/f1a3ee13" /* webpackChunkName: "locale_ko_46json_f1a3ee13" */),
      cache: true
    },
    {
      key: "locale_ko_46json_37eae153",
      load: () => import("#nuxt-i18n/37eae153" /* webpackChunkName: "locale_ko_46json_37eae153" */),
      cache: true
    }
  ],
  uk: [
    {
      key: "locale_uk_46json_97283177",
      load: () => import("#nuxt-i18n/97283177" /* webpackChunkName: "locale_uk_46json_97283177" */),
      cache: true
    },
    {
      key: "locale_uk_46json_0139bb06",
      load: () => import("#nuxt-i18n/0139bb06" /* webpackChunkName: "locale_uk_46json_0139bb06" */),
      cache: true
    },
    {
      key: "locale_uk_46json_11e5505c",
      load: () => import("#nuxt-i18n/11e5505c" /* webpackChunkName: "locale_uk_46json_11e5505c" */),
      cache: true
    },
    {
      key: "locale_uk_46json_2db93941",
      load: () => import("#nuxt-i18n/2db93941" /* webpackChunkName: "locale_uk_46json_2db93941" */),
      cache: true
    },
    {
      key: "locale_uk_46json_80620973",
      load: () => import("#nuxt-i18n/80620973" /* webpackChunkName: "locale_uk_46json_80620973" */),
      cache: true
    },
    {
      key: "locale_uk_46json_814f039d",
      load: () => import("#nuxt-i18n/814f039d" /* webpackChunkName: "locale_uk_46json_814f039d" */),
      cache: true
    },
    {
      key: "locale_uk_46json_52c69af6",
      load: () => import("#nuxt-i18n/52c69af6" /* webpackChunkName: "locale_uk_46json_52c69af6" */),
      cache: true
    },
    {
      key: "locale_uk_46json_5f0c49ba",
      load: () => import("#nuxt-i18n/5f0c49ba" /* webpackChunkName: "locale_uk_46json_5f0c49ba" */),
      cache: true
    },
    {
      key: "locale_uk_46json_95158ab9",
      load: () => import("#nuxt-i18n/95158ab9" /* webpackChunkName: "locale_uk_46json_95158ab9" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "en",
    name: "English",
    language: undefined
  },
  {
    code: "fr",
    name: "Français",
    language: undefined
  },
  {
    code: "nl",
    name: "Nederlands",
    language: undefined
  },
  {
    code: "de",
    name: "Deutsch",
    language: undefined
  },
  {
    code: "es",
    name: "Español",
    language: undefined
  },
  {
    code: "it",
    name: "Italiano",
    language: undefined
  },
  {
    code: "pl",
    name: "Polski (Beta)",
    language: undefined
  },
  {
    code: "ko",
    name: "한국어",
    language: undefined
  },
  {
    code: "uk",
    name: "Українська",
    language: undefined
  }
]

